uvex-press-list {
  .btn svg {
    top: calc(50% - 15px);
    padding: 0.2em 0.25em 0.15em;
    border: 2px solid var(--brand-primary, #ff6600);
    border-radius: 100%;
    transition: border-color 0.2s ease-in-out;
  }
  .btn:hover svg {
    border-color: #000;
  }
}
